import StaffDashboard from "@/components/Staff/StaffDashboard";
import { LayoutDashboard, Users, Building, Activity } from "lucide-react";

export default function AdminDashboardPage() {
    return (
        <StaffDashboard
            portalName="Back Office"
            roleLabel="Admin"
            statCards={[
                { label: "Active Dealers",  value: "—", icon: Building,        color: "text-blue-500"   },
                { label: "Total Users",     value: "—", icon: Users,           color: "text-violet-500" },
                { label: "Active Deals",    value: "—", icon: LayoutDashboard, color: "text-orange-500" },
                { label: "System Health",   value: "OK", icon: Activity,       color: "text-green-500"  },
            ]}
            quickLinks={[
                { label: "Pending Dealer Applications", to: "/admin/dealers/pending"          },
                { label: "Insurance Companies",         to: "/admin/insurance-companies"      },
                { label: "Warranty Companies",          to: "/admin/warranty-companies"       },
                { label: "Transport Companies",         to: "/admin/transport-companies"      },
                { label: "Salvage Companies",           to: "/admin/salvage-companies"        },
                { label: "Floor Plan Companies",        to: "/admin/floorplan-companies"      },
                { label: "Recurring Billing",           to: "/admin/billing"                  },
            ]}
        />
    );
}
